<template>
  <v-bottom-navigation
    v-if="isVisible"
    id="bottom-nav-shortcut"
    :grow="true"
    shift
    absolute
    :width="totalWidth"
    class="text-center"
  >
    <bottom-bar-navigation-item
      v-for="item in bottomBarNavigationItems"
      :key="item.hrefLink"
      :href-link="item.hrefLink"
      :text-to-show="item.textToShow"
      :icon="item.icon"
    />
  </v-bottom-navigation>
</template>

<script>
// Components
import bottomBarNavigationItem from "./BottomBarNavigationItem";

// TODO: WTF ???
const bottomBarNavigationItemFunction = require("./BottomBarNavigationItem");
const bottomBarNavigationItems = [
  bottomBarNavigationItemFunction.createNewBottomBarNavigationItem("/schedule", "navbar.schedule", "mdi-clock-outline"),
  bottomBarNavigationItemFunction.createNewBottomBarNavigationItem(
    "/project/1",
    "navbar.project",
    "mdi-file-document-edit-outline"
  ),
];

export default {
  components: {
    bottomBarNavigationItem,
  },
  data() {
    return {
      bottomBarNavigationItems,
    };
  },
  computed: {
    totalWidth() {
      return this.bottomBarNavigationItems.length * 100 + "px";
    },
    isVisible() {
      return this.$store.state.config.prefs.bottomNavbar;
    },
  },
};
</script>

<style>
.theme--dark #bottom-nav-shortcut {
  background-color: #3a3a3a !important;
}

.theme--light #bottom-nav-shortcut {
  background-color: #efefef !important;
}
</style>
